import React, { useState, useMemo, useEffect } from 'react';
import ClipLoader from "react-spinners/ClipLoader";
import readMessageIcon from "../../../../../../Assets/images/read-message.png";
import unreadMessageIcon from "../../../../../../Assets/images/unread-message.png";
import deleteIocn from "../../../../../../Assets/images/delete-icon.svg";
import { hasPermission } from "../../../Services/permission";

const NOTIFICATIONS_SECTION = "notifications";
const NOTIFICATIONS_MANAGE_KEY = ["notifications_manage"];

const NotificationList = ({ notifications, loading, userId }) => {
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [notificationState, setNotificationState] = useState(notifications);

    useEffect(() => {
        setNotificationState(notifications);
    }, [notifications]);

    const totalNotifications = notificationState.length;
    const totalPages = Math.ceil(totalNotifications / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;

    const currentNotifications = useMemo(() => {
        return notificationState.slice(startIndex, startIndex + itemsPerPage);
    }, [notificationState, startIndex, itemsPerPage]);

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const canManageCompanyNotifications = hasPermission({
        section: NOTIFICATIONS_SECTION,
        keys: NOTIFICATIONS_MANAGE_KEY,
    });

    return (
        <div className="table-cvr">
            <div className="table-inner mt-0">
                <p className="notificatio-title">{totalNotifications} Notifications</p>
                <table id="roleTable" className="table">
                    <thead>
                        <tr style={{ height: "35px" }}>
                            <th></th><th></th><th></th><th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="4" className="text-center py-4">
                                    <ClipLoader size={30} color="gray" />
                                </td>
                            </tr>
                        ) : currentNotifications.length === 0 ? (
                            <tr>
                                <td colSpan="4" className="text-center py-4 text-muted">
                                    No notifications found.
                                </td>
                            </tr>
                        ) : (
                            currentNotifications.map(({ id, message, time, isRead, to_user, onMarkAsRead, onDelete }, idx) => {
                                const iconSrc = isRead ? readMessageIcon : unreadMessageIcon;
                                const tooltipText = isRead ? "" : "Mark as read";

                                const isUserSpecific = to_user !== null
                                const isCompanyWide = to_user === null;
                                const canInteract = isUserSpecific || (isCompanyWide && canManageCompanyNotifications);

                                return (
                                    <tr key={id || idx}>
                                        <td className='notification-col1'>
                                            <p className={isRead ? 'mb-0' : 'bold-text'}>{message}</p>
                                        </td>
                                        <td className='notification-col2'>{time}</td>
                                        <td className='notification-col3'>
                                            <img className="read-icon" src={iconSrc} alt={isRead ? "read" : "unread"} title={tooltipText} style={{ cursor: canInteract && !isRead ? "pointer" : "not-allowed", opacity: canInteract ? 1 : 0.5, }}
                                                onClick={() => { if (canInteract && !isRead && onMarkAsRead) onMarkAsRead(id); }} />
                                        </td>
                                        <td className='notification-col4'>
                                            <a href="#" onClick={(e) => { e.preventDefault(); if (canInteract && onDelete) onDelete(id); }}
                                                style={{ pointerEvents: canInteract ? "auto" : "none", opacity: canInteract ? 1 : 0.5, }}>
                                                <img className="tb-icon" src={deleteIocn} alt="delete" />
                                            </a>
                                        </td>
                                    </tr>
                                );
                            })
                        )}
                    </tbody>
                </table>
            </div>

            <div className="dt-layout-row d-flex align-items-center justify-content-between mt-3">
                <div className="dt-length">
                    Showing{' '}
                    <select className="dt-input" value={itemsPerPage} onChange={e => { setItemsPerPage(+e.target.value); setCurrentPage(1); }} >
                        {[5, 10, 50, 100].map(n => (
                            <option key={n} value={n}>{n}</option>
                        ))}
                    </select>{' '}
                    of {totalNotifications} entries
                </div>
                <div className="dt-paging d-flex align-items-center" style={{ gap: '5px' }}>
                    <button className="dt-paging-button previous" disabled={currentPage === 1} onClick={() => handlePageChange(currentPage - 1)}>
                        Previous
                    </button>
                    {Array.from({ length: totalPages }).map((_, i) => (
                        <button key={i + 1} className={`dt-paging-button ${currentPage === i + 1 ? 'current' : ''}`} onClick={() => handlePageChange(i + 1)}>
                            {i + 1}
                        </button>
                    ))}
                    <button className="dt-paging-button next" disabled={currentPage === totalPages} onClick={() => handlePageChange(currentPage + 1)} >
                        Next
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NotificationList;